import React from 'react';
import { useDefaultCardData } from 'constants/cardDefaults';

import TwoHomeownerQuotesBlock from '../../useCases/TwoHomeownerQuotesBlock/TwoHomeownerQuotesBlock';

const WhatHomeownersAreSayingBlock = () => {
  const twoHomeownerQuotes = useDefaultCardData({ cardType: 'twoHomeownerQuotes' });
  return <TwoHomeownerQuotesBlock title="What Homeowners Are Saying" quotes={twoHomeownerQuotes} />;
};

export default WhatHomeownersAreSayingBlock;
